import React, { Component } from 'react'
import MainLogo from "../MainLogo";
import { withStyles } from "@material-ui/core"
import Slider from './Product/Slider'

const style = theme => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            margin: 30
        }
    },
})

class Identary extends Component {
    render() {
        const { classes } = this.props
        return (
            <div className={classes.root}>
                <div id="preloader">
                    <div className="pre-container">
                        <div className="logo-circle">Identary</div>
                    </div>
                </div>

                <MainLogo/>
                {/*<HeadContent/>*/}
                {/*<Stage/>*/}
                {/*<ThreeBox*/}
                {/*title1={"特徴"}*/}
                {/*title2={"特徴"}*/}
                {/*title3={"特徴"}*/}
                {/*/>*/}
                {/*<Resource/>*/}
                {/*<Day/>*/}
                {/*<About*/}
                {/*img={'img/ikuta.png'}*/}
                {/*title={'人類の進化を加速したい発明家'}*/}
                {/*/>*/}
                {/*<Resource/>*/}
                {/*<Session/>*/}
                {/*<Story/>*/}
                {/*<Course/>*/}
                {/*<ThreeBox*/}
                {/*title1={"Insight mind "}*/}
                {/*descr1={"参加者特典１"}*/}
                {/*img1={'img/insightmind.png'}*/}
                {/*/>*/}
                <Slider
                    content={
                        <>
                            1,「私を、どう見ているか？」から、全てが始まっている。<br/>
                            2,「アイデンティティ・シフト」と「自己強化サイクル」<br/>
                            3,「Enecolorの感情特性」と「関係性」<br/>
                            4,「感情」と「感覚」と「呼吸」の連動<br/>
                            5,「呼吸の開放」と「声色」と「プレゼン力」<br/>
                            6,「呼吸力」で「内観力」と「感情伝達力」を高める<br/>
                            7,「心とは？」「感情とは？」を図解した内面モデル<br/>
                            8,「メタ認知力」を高め「在り方を選択」する技術<br/>
                            9,「ポジティブの罠」を脱し「天才性を発揮」するには？<br/>
                            10,「行動力が発揮できない時」の深層心理<br/>
                            11,「高次目的」と「統合」をもたらす問いの技術<br/>
                            12,「Visionの統合」と「第3の道」の開き方<br/>
                            13,「統合された高次目的」を具現化するには？<br/>
                            14,「自己統合」と「自己実現」の「内なる全体地図」<br/>
                            15,「抽象的な価値」を、「具体的な事業」へ<br/>
                            16,「自分の軸ど真ん中」の仕事を作るには？<br/>
                            17,「自己開放」から「究極のフォーカス」を定める。<br/>
                        </>
                    }
                />
                {/*<AboutProduct*/}
                {/*title={'エグゼクティブコース'}*/}
                {/*tips={*/}
                {/*<>*/}
                {/*ファシリテータ*/}
                {/*<br/>*/}
                {/*人類の進化を加速したい発明家*/}
                {/*</>*/}
                {/*}*/}
                {/*content={*/}
                {/*<>*/}
                {/*ど真ん中を生きる。ど真ん中を活かす。<br/>*/}
                {/*ど真ん中を生きる。ど真ん中を活かす。<br/>*/}
                {/*ど真ん中を生きる。ど真ん中を活かす。<br/>*/}
                {/*ど真ん中を生きる。ど真ん中を活かす。<br/>*/}
                {/*ど真ん中を生きる。ど真ん中を活かす。<br/>*/}
                {/*</>*/}
                {/*}*/}
                {/*sign={*/}
                {/*'生田 知久'*/}
                {/*}*/}
                {/*img={'img/ikuta.png'}*/}
                {/*/>*/}
                {/*<PriceProduct/>*/}
                {/*<Footer/>*/}
            </div>
        );
    }
}

export default withStyles(style)(Identary)
